export const CountryLists =  [
    { name: "Afghanistan", flag: "🇦🇫", code: "AF", phone_country_code: "93" },
    { name: "Åland Islands", flag: "🇦🇽", code: "AX", phone_country_code: "358" },
    { name: "Albania", flag: "🇦🇱", code: "AL", phone_country_code: "355" },
    { name: "Algeria", flag: "🇩🇿", code: "DZ", phone_country_code: "213" },
    { name: "American Samoa", flag: "🇦🇸", code: "AS", phone_country_code: "1684" },
    { name: "Andorra", flag: "🇦🇩", code: "AD", phone_country_code: "376" },
    { name: "Angola", flag: "🇦🇴", code: "AO", phone_country_code: "244" },
    { name: "Anguilla", flag: "🇦🇮", code: "AI", phone_country_code: "1264" },
    { name: "Antarctica", flag: "🇦🇶", code: "AQ", phone_country_code: "672" },
    { name: "Antigua and Barbuda", flag: "🇦🇬", code: "AG", phone_country_code: "1268" },
    { name: "Argentina", flag: "🇦🇷", code: "AR", phone_country_code: "54" },
    { name: "Armenia", flag: "🇦🇲", code: "AM", phone_country_code: "374" },
    { name: "Aruba", flag: "🇦🇼", code: "AW", phone_country_code: "297" },
    { name: "Australia", flag: "🇦🇺", code: "AU", phone_country_code: "61" },
    { name: "Austria", flag: "🇦🇹", code: "AT", phone_country_code: "43" },
    { name: "Azerbaijan", flag: "🇦🇿", code: "AZ", phone_country_code: "994" },
    { name: "Bahamas", flag: "🇧🇸", code: "BS", phone_country_code: "1242" },
    { name: "Bahrain", flag: "🇧🇭", code: "BH", phone_country_code: "973" },
    { name: "Bangladesh", flag: "🇧🇩", code: "BD", phone_country_code: "880" },
    { name: "Barbados", flag: "🇧🇧", code: "BB", phone_country_code: "1246" },
    { name: "Belarus", flag: "🇧🇾", code: "BY", phone_country_code: "375" },
    { name: "Belgium", flag: "🇧🇪", code: "BE", phone_country_code: "32" },
    { name: "Belize", flag: "🇧🇿", code: "BZ", phone_country_code: "501" },
    { name: "Benin", flag: "🇧🇯", code: "BJ", phone_country_code: "229" },
    { name: "Bermuda", flag: "🇧🇲", code: "BM", phone_country_code: "1441" },
    { name: "Bhutan", flag: "🇧🇹", code: "BT", phone_country_code: "975" },
    { name: "Bolivia, Plurinational State of", flag: "🇧🇴", code: "BO", phone_country_code: "591" },
    { name: "Bosnia and Herzegovina", flag: "🇧🇦", code: "BA", phone_country_code: "387" },
    { name: "Botswana", flag: "🇧🇼", code: "BW", phone_country_code: "267" },
    { name: "Bouvet Island", flag: "🇧🇻", code: "BV", phone_country_code: "47" },
    { name: "Brazil", flag: "🇧🇷", code: "BR", phone_country_code: "55" },
    { name: "British Indian Ocean Territory", flag: "🇮🇴", code: "IO", phone_country_code: "246" },
    { name: "Brunei Darussalam", flag: "🇧🇳", code: "BN", phone_country_code: "673" },
    { name: "Bulgaria", flag: "🇧🇬", code: "BG", phone_country_code: "359" },
    { name: "Burkina Faso", flag: "🇧🇫", code: "BF", phone_country_code: "226" },
    { name: "Burundi", flag: "🇧🇮", code: "BI", phone_country_code: "257" },
    { name: "Cambodia", flag: "🇰🇭", code: "KH", phone_country_code: "855" },
    { name: "Cameroon", flag: "🇨🇲", code: "CM", phone_country_code: "237" },
    { name: "Campione d'Italia", flag: "🇮🇹", code: "IT", phone_country_code: "41" },
    { name: "Canada", flag: "🇨🇦", code: "CA", phone_country_code: "1" },
    { name: "Cape Verde", flag: "🇨🇻", code: "CV", phone_country_code: "238" },
    { name: "Cayman Islands", flag: "🇰🇾", code: "KY", phone_country_code: "345" },
    { name: "Central African Republic", flag: "🇨🇫", code: "CF", phone_country_code: "236" },
    { name: "Chad", flag: "🇹🇩", code: "TD", phone_country_code: "235" },
    { name: "Chile", flag: "🇨🇱", code: "CL", phone_country_code: "56" },
    { name: "China", flag: "🇨🇳", code: "CN", phone_country_code: "86" },
    { name: "Christmas Island", flag: "🇨🇽", code: "CX", phone_country_code: "61" },
    { name: "Cocos (Keeling) Islands", flag: "🇨🇨", code: "CC", phone_country_code: "61" },
    { name: "Colombia", flag: "🇨🇴", code: "CO", phone_country_code: "57" },
    { name: "Comoros", flag: "🇰🇲", code: "KM", phone_country_code: "269" },
    { name: "Congo", flag: "🇨🇬", code: "CG", phone_country_code: "242" },
    { name: "Congo, The Democratic Republic of the Congo", flag: "🇨🇩", code: "CD", phone_country_code: "243" },
    { name: "Cook Islands", flag: "🇨🇰", code: "CK", phone_country_code: "682" },
    { name: "Costa Rica", flag: "🇨🇷", code: "CR", phone_country_code: "506" },
    { name: "Côte d'Ivoire", flag: "🇨🇮", code: "CI", phone_country_code: "225" },
    { name: "Croatia", flag: "🇭🇷", code: "HR", phone_country_code: "385" },
    { name: "Cuba", flag: "🇨🇺", code: "CU", phone_country_code: "53" },
    { name: "Cyprus", flag: "🇨🇾", code: "CY", phone_country_code: "357" },
    { name: "Czech Republic", flag: "🇨🇿", code: "CZ", phone_country_code: "420" },
    { name: "Denmark", flag: "🇩🇰", code: "DK", phone_country_code: "45" },
    { name: "Djibouti", flag: "🇩🇯", code: "DJ", phone_country_code: "253" },
    { name: "Dominica", flag: "🇩🇲", code: "DM", phone_country_code: "1767" },
    { name: "Dominican Republic", flag: "🇩🇴", code: "DO", phone_country_code: "1849" },
    { name: "Ecuador", flag: "🇪🇨", code: "EC", phone_country_code: "593" },
    { name: "Egypt", flag: "🇪🇬", code: "EG", phone_country_code: "20" },
    { name: "El Salvador", flag: "🇸🇻", code: "SV", phone_country_code: "503" },
    { name: "Equatorial Guinea", flag: "🇬🇶", code: "GQ", phone_country_code: "240" },
    { name: "Eritrea", flag: "🇪🇷", code: "ER", phone_country_code: "291" },
    { name: "Estonia", flag: "🇪🇪", code: "EE", phone_country_code: "372" },
    { name: "Ethiopia", flag: "🇪🇹", code: "ET", phone_country_code: "251" },
    { name: "Falkland Islands (Malvinas)", flag: "🇫🇰", code: "FK", phone_country_code: "500" },
    { name: "Faroe Islands", flag: "🇫🇴", code: "FO", phone_country_code: "298" },
    { name: "Fiji", flag: "🇫🇯", code: "FJ", phone_country_code: "679" },
    { name: "Finland", flag: "🇫🇮", code: "FI", phone_country_code: "358" },
    { name: "France", flag: "🇫🇷", code: "FR", phone_country_code: "33" },
    { name: "French Guiana", flag: "🇬🇫", code: "GF", phone_country_code: "594" },
    { name: "French Polynesia", flag: "🇵🇫", code: "PF", phone_country_code: "689" },
    { name: "French Southern Territories", flag: "🇹🇫", code: "TF", phone_country_code: "262" },
    { name: "Gabon", flag: "🇬🇦", code: "GA", phone_country_code: "241" },
    { name: "Gambia", flag: "🇬🇲", code: "GM", phone_country_code: "220" },
    { name: "Georgia", flag: "🇬🇪", code: "GE", phone_country_code: "995" },
    { name: "Germany", flag: "🇩🇪", code: "DE", phone_country_code: "49" },
    { name: "Ghana", flag: "🇬🇭", code: "GH", phone_country_code: "233" },
    { name: "Gibraltar", flag: "🇬🇮", code: "GI", phone_country_code: "350" },
    { name: "Greece", flag: "🇬🇷", code: "GR", phone_country_code: "30" },
    { name: "Greenland", flag: "🇬🇱", code: "GL", phone_country_code: "299" },
    { name: "Grenada", flag: "🇬🇩", code: "GD", phone_country_code: "1473" },
    { name: "Guadeloupe", flag: "🇬🇵", code: "GP", phone_country_code: "590" },
    { name: "Guam", flag: "🇬🇺", code: "GU", phone_country_code: "1671" },
    { name: "Guatemala", flag: "🇬🇹", code: "GT", phone_country_code: "502" },
    { name: "Guernsey", flag: "🇬🇬", code: "GG", phone_country_code: "44" },
    { name: "Guinea", flag: "🇬🇳", code: "GN", phone_country_code: "224" },
    { name: "Guinea-Bissau", flag: "🇬🇼", code: "GW", phone_country_code: "245" },
    { name: "Guyana", flag: "🇬🇾", code: "GY", phone_country_code: "592" },
    { name: "Haiti", flag: "🇭🇹", code: "HT", phone_country_code: "509" },
    { name: "Heard Island and Mcdonald Islands", flag: "🇭🇲", code: "HM", phone_country_code: "672" },
    { name: "Holy See (Vatican City State)", flag: "🇻🇦", code: "VA", phone_country_code: "379" },
    { name: "Honduras", flag: "🇭🇳", code: "HN", phone_country_code: "504" },
    { name: "Hong Kong", flag: "🇭🇰", code: "HK", phone_country_code: "852" },
    { name: "Hungary", flag: "🇭🇺", code: "HU", phone_country_code: "36" },
    { name: "Iceland", flag: "🇮🇸", code: "IS", phone_country_code: "354" },
    { name: "India", flag: "🇮🇳", code: "IN", phone_country_code: "91" },
    { name: "Indonesia", flag: "🇮🇩", code: "ID", phone_country_code: "62" },
    { name: "Iran, Islamic Republic of Persian Gulf", flag: "🇮🇷", code: "IR", phone_country_code: "98" },
    { name: "Iraq", flag: "🇮🇶", code: "IQ", phone_country_code: "964" },
    { name: "Ireland", flag: "🇮🇪", code: "IE", phone_country_code: "353" },
    { name: "Isle of Man", flag: "🇮🇲", code: "IM", phone_country_code: "44" },
    { name: "Israel", flag: "🇮🇱", code: "IL", phone_country_code: "972" },
    { name: "Italy", flag: "🇮🇹", code: "IT", phone_country_code: "39" },
    { name: "Jamaica", flag: "🇯🇲", code: "JM", phone_country_code: "1876" },
    { name: "Japan", flag: "🇯🇵", code: "JP", phone_country_code: "81" },
    { name: "Jersey", flag: "🇯🇪", code: "JE", phone_country_code: "44" },
    { name: "Jordan", flag: "🇯🇴", code: "JO", phone_country_code: "962" },
    { name: "Kazakhstan", flag: "🇰🇿", code: "KZ", phone_country_code: "7" },
    { name: "Kenya", flag: "🇰🇪", code: "KE", phone_country_code: "254" },
    { name: "Kiribati", flag: "🇰🇮", code: "KI", phone_country_code: "686" },
    { name: "Korea, Democratic People's Republic of Korea", flag: "🇰🇵", code: "KP", phone_country_code: "850" },
    { name: "Korea, Republic of South Korea", flag: "🇰🇷", code: "KR", phone_country_code: "82" },
    { name: "Kosovo", flag: "🇽🇰", code: "XK", phone_country_code: "383" },
    { name: "Kuwait", flag: "🇰🇼", code: "KW", phone_country_code: "965" },
    { name: "Kyrgyzstan", flag: "🇰🇬", code: "KG", phone_country_code: "996" },
    { name: "Laos", flag: "🇱🇦", code: "LA", phone_country_code: "856" },
    { name: "Latvia", flag: "🇱🇻", code: "LV", phone_country_code: "371" },
    { name: "Lebanon", flag: "🇱🇧", code: "LB", phone_country_code: "961" },
    { name: "Lesotho", flag: "🇱🇸", code: "LS", phone_country_code: "266" },
    { name: "Liberia", flag: "🇱🇷", code: "LR", phone_country_code: "231" },
    { name: "Libyan Arab Jamahiriya", flag: "🇱🇾", code: "LY", phone_country_code: "218" },
    { name: "Liechtenstein", flag: "🇱🇮", code: "LI", phone_country_code: "423" },
    { name: "Lithuania", flag: "🇱🇹", code: "LT", phone_country_code: "370" },
    { name: "Luxembourg", flag: "🇱🇺", code: "LU", phone_country_code: "352" },
    { name: "Macao", flag: "🇲🇴", code: "MO", phone_country_code: "853" },
    { name: "Macedonia", flag: "🇲🇰", code: "MK", phone_country_code: "389" },
    { name: "Madagascar", flag: "🇲🇬", code: "MG", phone_country_code: "261" },
    { name: "Malawi", flag: "🇲🇼", code: "MW", phone_country_code: "265" },
    { name: "Malaysia", flag: "🇲🇾", code: "MY", phone_country_code: "60" },
    { name: "Maldives", flag: "🇲🇻", code: "MV", phone_country_code: "960" },
    { name: "Mali", flag: "🇲🇱", code: "ML", phone_country_code: "223" },
    { name: "Malta", flag: "🇲🇹", code: "MT", phone_country_code: "356" },
    { name: "Marshall Islands", flag: "🇲🇭", code: "MH", phone_country_code: "692" },
    { name: "Martinique", flag: "🇲🇶", code: "MQ", phone_country_code: "596" },
    { name: "Mauritania", flag: "🇲🇷", code: "MR", phone_country_code: "222" },
    { name: "Mauritius", flag: "🇲🇺", code: "MU", phone_country_code: "230" },
    { name: "Mayotte", flag: "🇾🇹", code: "YT", phone_country_code: "262" },
    { name: "Mexico", flag: "🇲🇽", code: "MX", phone_country_code: "52" },
    { name: "Micronesia, Federated States of Micronesia", flag: "🇫🇲", code: "FM", phone_country_code: "691" },
    { name: "Moldova", flag: "🇲🇩", code: "MD", phone_country_code: "373" },
    { name: "Monaco", flag: "🇲🇨", code: "MC", phone_country_code: "377" },
    { name: "Mongolia", flag: "🇲🇳", code: "MN", phone_country_code: "976" },
    { name: "Montenegro", flag: "🇲🇪", code: "ME", phone_country_code: "382" },
    { name: "Montserrat", flag: "🇲🇸", code: "MS", phone_country_code: "1664" },
    { name: "Morocco", flag: "🇲🇦", code: "MA", phone_country_code: "212" },
    { name: "Mozambique", flag: "🇲🇿", code: "MZ", phone_country_code: "258" },
    { name: "Myanmar", flag: "🇲🇲", code: "MM", phone_country_code: "95" },
    { name: "Namibia", flag: "🇳🇦", code: "NA", phone_country_code: "264" },
    { name: "Nauru", flag: "🇳🇷", code: "NR", phone_country_code: "674" },
    { name: "Nepal", flag: "🇳🇵", code: "NP", phone_country_code: "977" },
    { name: "Netherlands", flag: "🇳🇱", code: "NL", phone_country_code: "31" },
    { name: "Netherlands Antilles", flag: "", code: "AN", phone_country_code: "599" },
    { name: "New Caledonia", flag: "🇳🇨", code: "NC", phone_country_code: "687" },
    { name: "New Zealand", flag: "🇳🇿", code: "NZ", phone_country_code: "64" },
    { name: "Nicaragua", flag: "🇳🇮", code: "NI", phone_country_code: "505" },
    { name: "Niger", flag: "🇳🇪", code: "NE", phone_country_code: "227" },
    { name: "Nigeria", flag: "🇳🇬", code: "NG", phone_country_code: "234" },
    { name: "Niue", flag: "🇳🇺", code: "NU", phone_country_code: "683" },
    { name: "Norfolk Island", flag: "🇳🇫", code: "NF", phone_country_code: "672" },
    { name: "Northern Mariana Islands", flag: "🇲🇵", code: "MP", phone_country_code: "1670" },
    { name: "Norway", flag: "🇳🇴", code: "NO", phone_country_code: "47" },
    { name: "Oman", flag: "🇴🇲", code: "OM", phone_country_code: "968" },
    { name: "Pakistan", flag: "🇵🇰", code: "PK", phone_country_code: "92" },
    { name: "Palau", flag: "🇵🇼", code: "PW", phone_country_code: "680" },
    { name: "Palestinian Territory, Occupied", flag: "🇵🇸", code: "PS", phone_country_code: "970" },
    { name: "Panama", flag: "🇵🇦", code: "PA", phone_country_code: "507" },
    { name: "Papua New Guinea", flag: "🇵🇬", code: "PG", phone_country_code: "675" },
    { name: "Paraguay", flag: "🇵🇾", code: "PY", phone_country_code: "595" },
    { name: "Peru", flag: "🇵🇪", code: "PE", phone_country_code: "51" },
    { name: "Philippines", flag: "🇵🇭", code: "PH", phone_country_code: "63" },
    { name: "Pitcairn", flag: "🇵🇳", code: "PN", phone_country_code: "64" },
    { name: "Poland", flag: "🇵🇱", code: "PL", phone_country_code: "48" },
    { name: "Portugal", flag: "🇵🇹", code: "PT", phone_country_code: "351" },
    { name: "Puerto Rico", flag: "🇵🇷", code: "PR", phone_country_code: "1939" },
    { name: "Qatar", flag: "🇶🇦", code: "QA", phone_country_code: "974" },
    { name: "Romania", flag: "🇷🇴", code: "RO", phone_country_code: "40" },
    { name: "Russia", flag: "🇷🇺", code: "RU", phone_country_code: "7" },
    { name: "Rwanda", flag: "🇷🇼", code: "RW", phone_country_code: "250" },
    { name: "Reunion", flag: "🇷🇪", code: "RE", phone_country_code: "262" },
    { name: "Saint Barthelemy", flag: "🇧🇱", code: "BL", phone_country_code: "590" },
    { name: "Saint Helena, Ascension and Tristan Da Cunha", flag: "🇸🇭", code: "SH", phone_country_code: "290" },
    { name: "Saint Kitts and Nevis", flag: "🇰🇳", code: "KN", phone_country_code: "1869" },
    { name: "Saint Lucia", flag: "🇱🇨", code: "LC", phone_country_code: "1758" },
    { name: "Saint Martin", flag: "🇲🇫", code: "MF", phone_country_code: "590" },
    { name: "Saint Pierre and Miquelon", flag: "🇵🇲", code: "PM", phone_country_code: "508" },
    { name: "Saint Vincent and the Grenadines", flag: "🇻🇨", code: "VC", phone_country_code: "1784" },
    { name: "Samoa", flag: "🇼🇸", code: "WS", phone_country_code: "685" },
    { name: "San Marino", flag: "🇸🇲", code: "SM", phone_country_code: "378" },
    { name: "Sao Tome and Principe", flag: "🇸🇹", code: "ST", phone_country_code: "239" },
    { name: "Saudi Arabia", flag: "🇸🇦", code: "SA", phone_country_code: "966" },
    { name: "Senegal", flag: "🇸🇳", code: "SN", phone_country_code: "221" },
    { name: "Serbia", flag: "🇷🇸", code: "RS", phone_country_code: "381" },
    { name: "Seychelles", flag: "🇸🇨", code: "SC", phone_country_code: "248" },
    { name: "Sierra Leone", flag: "🇸🇱", code: "SL", phone_country_code: "232" },
    { name: "Singapore", flag: "🇸🇬", code: "SG", phone_country_code: "65" },
    { name: "Slovakia", flag: "🇸🇰", code: "SK", phone_country_code: "421" },
    { name: "Slovenia", flag: "🇸🇮", code: "SI", phone_country_code: "386" },
    { name: "Solomon Islands", flag: "🇸🇧", code: "SB", phone_country_code: "677" },
    { name: "Somalia", flag: "🇸🇴", code: "SO", phone_country_code: "252" },
    { name: "South Africa", flag: "🇿🇦", code: "ZA", phone_country_code: "27" },
    { name: "South Sudan", flag: "🇸🇸", code: "SS", phone_country_code: "211" },
    { name: "South Georgia and the South Sandwich Islands", flag: "🇬🇸", code: "GS", phone_country_code: "500" },
    { name: "Spain", flag: "🇪🇸", code: "ES", phone_country_code: "34" },
    { name: "Sri Lanka", flag: "🇱🇰", code: "LK", phone_country_code: "94" },
    { name: "Sudan", flag: "🇸🇩", code: "SD", phone_country_code: "249" },
    { name: "Suriname", flag: "🇸🇷", code: "SR", phone_country_code: "597" },
    { name: "Svalbard and Jan Mayen", flag: "🇸🇯", code: "SJ", phone_country_code: "47" },
    { name: "Eswatini", flag: "🇸🇿", code: "SZ", phone_country_code: "268" },
    { name: "Sweden", flag: "🇸🇪", code: "SE", phone_country_code: "46" },
    { name: "Switzerland", flag: "🇨🇭", code: "CH", phone_country_code: "41" },
    { name: "Syrian Arab Republic", flag: "🇸🇾", code: "SY", phone_country_code: "963" },
    { name: "Taiwan", flag: "🇹🇼", code: "TW", phone_country_code: "886" },
    { name: "Tajikistan", flag: "🇹🇯", code: "TJ", phone_country_code: "992" },
    { name: "Tanzania, United Republic of Tanzania", flag: "🇹🇿", code: "TZ", phone_country_code: "255" },
    { name: "Thailand", flag: "🇹🇭", code: "TH", phone_country_code: "66" },
    { name: "Timor-Leste", flag: "🇹🇱", code: "TL", phone_country_code: "670" },
    { name: "Togo", flag: "🇹🇬", code: "TG", phone_country_code: "228" },
    { name: "Tokelau", flag: "🇹🇰", code: "TK", phone_country_code: "690" },
    { name: "Tonga", flag: "🇹🇴", code: "TO", phone_country_code: "676" },
    { name: "Trinidad and Tobago", flag: "🇹🇹", code: "TT", phone_country_code: "1868" },
    { name: "Tunisia", flag: "🇹🇳", code: "TN", phone_country_code: "216" },
    { name: "Turkey", flag: "🇹🇷", code: "TR", phone_country_code: "90" },
    { name: "Turkmenistan", flag: "🇹🇲", code: "TM", phone_country_code: "993" },
    { name: "Turks and Caicos Islands", flag: "🇹🇨", code: "TC", phone_country_code: "1649" },
    { name: "Tuvalu", flag: "🇹🇻", code: "TV", phone_country_code: "688" },
    { name: "Uganda", flag: "🇺🇬", code: "UG", phone_country_code: "256" },
    { name: "Ukraine", flag: "🇺🇦", code: "UA", phone_country_code: "380" },
    { name: "United Arab Emirates", flag: "🇦🇪", code: "AE", phone_country_code: "971" },
    { name: "United Kingdom", flag: "🇬🇧", code: "GB", phone_country_code: "44" },
    { name: "United States", flag: "🇺🇸", code: "US", phone_country_code: "1" },
    { name: "Uruguay", flag: "🇺🇾", code: "UY", phone_country_code: "598" },
    { name: "Uzbekistan", flag: "🇺🇿", code: "UZ", phone_country_code: "998" },
    { name: "Vanuatu", flag: "🇻🇺", code: "VU", phone_country_code: "678" },
    { name: "Venezuela, Bolivarian Republic of Venezuela", flag: "🇻🇪", code: "VE", phone_country_code: "58" },
    { name: "Vietnam", flag: "🇻🇳", code: "VN", phone_country_code: "84" },
    { name: "Virgin Islands, British", flag: "🇻🇬", code: "VG", phone_country_code: "1284" },
    { name: "Virgin Islands, U.S.", flag: "🇻🇮", code: "VI", phone_country_code: "1340" },
    { name: "Wallis and Futuna", flag: "🇼🇫", code: "WF", phone_country_code: "681" },
    { name: "Yemen", flag: "🇾🇪", code: "YE", phone_country_code: "967" },
    { name: "Zambia", flag: "🇿🇲", code: "ZM", phone_country_code: "260" },
    { name: "Zimbabwe", flag: "🇿🇼", code: "ZW", phone_country_code: "263" },
    
];